import { render, staticRenderFns } from "./PickIndex.vue?vue&type=template&id=66707120&scoped=true&"
import script from "./PickIndex.vue?vue&type=script&lang=js&"
export * from "./PickIndex.vue?vue&type=script&lang=js&"
import style0 from "./PickIndex.vue?vue&type=style&index=0&id=66707120&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66707120",
  null
  
)

export default component.exports